module.exports = __webpack_public_path__ + "static/img/32.1fedca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/32.png
// module id = h03d
// module chunks = 1